export default {
	data() {
		return {
			t:         null,
			isPending: false
		};
	},
	methods: {
		async clearChangeHandleTimeout(timeout, callback) {
			clearTimeout(this.t);
		},
		async changeHandleTimeoutHandle(timeout, callback) {
			this.isPending = true;
			this.clearChangeHandleTimeout();
			this.t = setTimeout(() => {
				this.isPending = false;
				callback();
			}, timeout);
		},
	}
};
